import { post } from '@/common/services/request.js'

let state = {
  type: 'query',
  isOpen: true,
  isTimeOut: false,
  todayIsOpen: true,
  shopTimeList: [],
  todayTime: '',
  info: {
    shopConfig: {
      isOpen: true,
      autoOpen: true
    }
  }
}

for (let i = 1; i <= 7; i++) {
  state.shopTimeList.push({
    weekDay: i,
    isOpen: true,
    openTime: '09:00',
    closeTime: '17:00'
  })
}

const mutations = {
  /** 设置店铺信息 */
  setShopInfo(state, info = {}) {
    state.info = info
    /** 店铺开启状态 */
    if (state.info.shopConfig) {
      state.isOpen = !state.info.shopConfig.isOpen ? false : true
    }
    if (state.info.shopConfig) {
      state.autoOpen = !state.info.shopConfig.autoOpen ? false : true
    }
    /** 店铺的营业时间表 */
    let openingHours = (state.info.shopConfig && state.info.shopConfig.openingHours) || []
    openingHours &
      openingHours.forEach(item => {
        if (!item.openTime) {
          item.openTime = '09:00'
        }
        if (!item.closeTime) {
          item.closeTime = '17:00'
        }
      })

    if (openingHours.length > 0) {
      state.shopTimeList = JSON.parse(JSON.stringify(openingHours))
    }
    /** 店铺今天开启状态及营业时间 */
    let today = new Date().getDay() === 0 ? 7 : new Date().getDay()
    let list = (state.info.shopConfig && state.info.shopConfig.openingHours) || []
    if (list.length > 0) {
      list.forEach(item => {
        if (item.weekDay === today) {
          state.todayIsOpen = state.autoOpen ? item.isOpen : state.isOpen
          state.todayTime = `${item.openTime} - ${item.closeTime}`
        }
      })
    } else {
      state.todayTime = '09:00 - 17:00'
    }

    let endTime = state.todayTime.split('-')[1] || '17:00'
    let startTime = state.todayTime.split('-')[0] || '09:00'
    let date = new Date()
    let hh = date.getHours()
    let mm = date.getMinutes()
    let isTimeOut = new Date(`1970-1-1 ${endTime}`) < new Date(`1970-1-1 ${hh}:${mm}`)
    if (!isTimeOut && state.autoOpen) {
      isTimeOut = new Date(`1970-1-1 ${startTime}`) > new Date(`1970-1-1 ${hh}:${mm}`)
    }
    state.isTimeOut = isTimeOut
    if (isTimeOut) {
      state.isOpen = false
    }
  },

  setShopIsOpen(state, val) {
    state.isOpen = !!val
    /** 店铺今天开启状态及营业时间 */
    let today = new Date().getDay() === 0 ? 7 : new Date().getDay()
    let list = (state.info.shopConfig && state.info.shopConfig.openingHours) || []
    if (list.length > 0) {
      list.forEach(item => {
        if (item.weekDay === today) {
          state.todayIsOpen = state.autoOpen ? item.isOpen : state.isOpen
          state.todayTime = `${item.openTime} - ${item.closeTime}`
        }
      })
    } else {
      state.todayTime = '09:00 - 17:00'
    }
  },
  /** 删除店铺信息r */
  clearShopInfo(state) {
    state = {
      isOpen: false,
      todayIsOpen: false,
      info: {}
    }
  },
  // 修改店铺数据状态 查询&修改
  updateShopDataType(state, type) {
    state.type = type
  }
}

const actions = {
  setShopInfo: ({ commit }, info) => {
    commit('setShopInfo', info)
  },
  clearShopInfo: ({ commit }) => {
    commit('clearShopInfo')
  },
  setShopIsOpen: ({ commit }, val) => {
    commit('setShopIsOpen', val)
  },
  updateShopDataType: ({ commit }, type) => {
    commit('updateShopDataType', type)
  }
}
export default {
  state,
  actions,
  mutations
}
